import { useQueryClient } from '@tanstack/react-query';
import { getRouteApi, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { LoginPage } from '@/features/auth/login-page';
import { safeRedirect } from './login-search';

const route = getRouteApi('/login');

export function LoginRoute() {
  const search = route.useSearch();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const onAuthenticated = useCallback(() => {
    queryClient.removeQueries({ queryKey: ['session'] });
    void navigate({ href: safeRedirect(search.redirect), replace: true });
  }, [navigate, queryClient, search.redirect]);
  return <LoginPage initialTenant={search.tenant} onAuthenticated={onAuthenticated} />;
}
